

















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { User, UserGroup, UserRole } from '@/interfaces/user.interface';
import { VALIDATION_RULES } from '@/helpers/helpers';
import { namespace } from 'vuex-class';

const usersModule = namespace('users');

@Component
export default class UserEdit extends Vue {
  @usersModule.State roles!: UserRole[];
  @usersModule.State groups!: UserGroup[];
  @Prop({default: {}}) user!: User;

  userEmailRules = [...VALIDATION_RULES.required, ...VALIDATION_RULES.email];
  userNameRules = [...VALIDATION_RULES.required];
  userPasswordRules = [...VALIDATION_RULES.password];

  valid = false;

  handleSubmit() {
    this.valid && this.$store.dispatch('users/UPDATE_USER', {
      user: this.user
    });
    // TODO: Close user after edit
  }

  // TODO
  // updateRole() {
  //   const role = this.roles && this.roles.find(r => r.uuid === this.user.roleUuid) || {}
  //   console.log('role', role);
  //   this.user.roleName = role.name
  // }
  // updateGroup() {
  //   const group = this.groups && this.groups.find(g => g.uuid === this.user.groupUuid) || {}
  //   console.log('group', group);
  //   this.user.groupName = group.name
  // }

}
